export enum Team {
  BizTeam = 'Biz Team',
}

export enum Feature {
  TeamlessCollaborationPrompt = 'Teamless Collaboration Prompt',
}
